module.exports = __webpack_public_path__ + "static/img/home_type_icon_sbcx.a84a5d22.webp";